import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography
} from "@material-ui/core";
import ConfirmButton, {
  ConfirmButtonTransitionState
} from "@saleor/components/ConfirmButton";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import TableHead from "@saleor/components/TableHead";
import { VoucherBrandGroupsDetail_voucher_voucherTenants } from "@saleor/discounts/types/VoucherBrandGroupsDetail";
import { buttonMessages } from "@saleor/intl";
import React from "react";
import { FormattedMessage } from "react-intl";

import Form from "../../../components/Form";
import { Grid } from "../../../components/Grid";
import useBrandGroupSingleEditDialogStyles from "./styles";

interface FormData {
  id: string;
  smoDiscountShare: number;
  tenantDiscountShare: number;
}

export interface BrandSingleEditDialogProps {
  confirmButtonState: ConfirmButtonTransitionState;
  onClose: () => void;
  onSubmit: (data: FormData) => void;
  eligibleStoreInfo: VoucherBrandGroupsDetail_voucher_voucherTenants;
  open: boolean;
}

const BrandSingleEditDialog: React.FC<BrandSingleEditDialogProps> = props => {
  const {
    onClose,
    onSubmit,
    open,
    eligibleStoreInfo,
    confirmButtonState
  } = props;
  const classes = useBrandGroupSingleEditDialogStyles(props);
  const tenantinfo = eligibleStoreInfo?.tenant;
  const initialForm: FormData = {
    id: "",
    smoDiscountShare: 100,
    tenantDiscountShare: 0
  };

  const handleSubmit = event => {
    const { smoDiscountShare, tenantDiscountShare } = event;

    const payload = {
      id: eligibleStoreInfo?.id,
      smoDiscountShare: parseFloat(smoDiscountShare > 0 ? smoDiscountShare : 0),
      tenantDiscountShare: parseFloat(
        tenantDiscountShare > 0 ? tenantDiscountShare : 0
      )
    };

    onSubmit(payload);
  };

  return (
    <>
      <Dialog onClose={onClose} open={open} fullWidth maxWidth="md">
        <Form initial={initialForm} onSubmit={handleSubmit}>
          {({ data, change }) => (
            <>
              <DialogTitle className={classes.assignBrands}>
                Edit Discount
              </DialogTitle>
              <DialogContent className={classes.discountContent}>
                <Box
                  style={{
                    marginBottom: 5
                  }}
                >
                  <Grid variant="uniform">
                    <Box>
                      <Typography
                        component="span"
                        style={{ marginBottom: 2 }}
                        className={classes.sellerName}
                      >
                        Seller (Brand) Name
                      </Typography>
                      <Typography
                        component="div"
                        className={classes.selectedSellerName}
                      >
                        {`${tenantinfo?.brand?.name} - ${tenantinfo?.brand?.legalName}`}
                      </Typography>
                    </Box>
                  </Grid>
                  <ResponsiveTable key="table">
                    <TableHead
                      colSpan={3}
                      disabled={false}
                      items={[]}
                      hideCheckBox
                    >
                      <TableCell
                        className={classes.colName}
                        style={{ paddingLeft: 0 }}
                      >
                        <FormattedMessage defaultMessage="Store Name" />
                      </TableCell>
                      <TableCell className={classes.colPrice}>
                        <FormattedMessage defaultMessage="Tenant Discount" />
                      </TableCell>
                      <TableCell className={classes.colPrice}>
                        <FormattedMessage defaultMessage="SMOP Discount" />
                      </TableCell>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell style={{ paddingLeft: 0 }}>
                          <Typography
                            component="span"
                            className={classes.colStoreName}
                          >
                            {`${tenantinfo?.mall?.name}`}
                          </Typography>
                        </TableCell>
                        <TableCell className={classes.colPrice}>
                          <TextField
                            label="Tenant Discount"
                            fullWidth
                            name="tenantDiscountShare"
                            value={data.tenantDiscountShare || 0}
                            onChange={change}
                            onKeyPress={event => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography
                                    component="span"
                                    variant="caption"
                                  >
                                    %
                                  </Typography>
                                </InputAdornment>
                              )
                            }}
                          />
                        </TableCell>
                        <TableCell className={classes.colPrice}>
                          <TextField
                            label="SMOP Discount"
                            fullWidth
                            name="smoDiscountShare"
                            value={data.smoDiscountShare || 0}
                            onChange={change}
                            onKeyPress={event => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Typography
                                    component="span"
                                    variant="caption"
                                  >
                                    %
                                  </Typography>
                                </InputAdornment>
                              )
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </ResponsiveTable>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} type="button">
                  <FormattedMessage {...buttonMessages.cancel} />
                </Button>
                <ConfirmButton
                  transitionState={confirmButtonState}
                  color="primary"
                  variant="contained"
                  type="submit"
                >
                  <FormattedMessage
                    defaultMessage="Save"
                    description="button"
                  />
                </ConfirmButton>
              </DialogActions>
            </>
          )}
        </Form>
      </Dialog>
    </>
  );
};

BrandSingleEditDialog.displayName = "BrandSingleEditDialog";
export default BrandSingleEditDialog;
